import { cn } from '@/shared/lib/utils';

interface MarcoAvatarProps {
  className?: string;
}

const MarcoAvatar = ({ className }: MarcoAvatarProps) => (
  <img
    src="/images/marco-avatar.png"
    alt=""
    aria-hidden="true"
    draggable={false}
    data-testid="marco-avatar"
    className={cn('shrink-0 select-none rounded-full', className)}
  />
);

export default MarcoAvatar;
